export const socialsData = {
    github: 'https://github.com/rht16',
   
    linkedIn: 'https://www.linkedin.com/in/rohit-kumar-120290200/',
   
    codepen: 'https://codepen.io/rohit0796',
    twitter: 'https://twitter.com/rht_16_',
   
    blogger: 'https://medium.com/@rohitkrrt',
    medium: 'https://medium.com/@rohitkrrt',
    stackOverflow: 'https://stackoverflow.com/users/17498268/rohit-kumar',
   
}